import NjesiRaportueseTable from "../components/NjesiRaportuese/NjesiRaportueseTable";
import StartingPageContent from "../components/StartingPage/StartingPageContent";
const NjesiRaportuese = () => {
  return (
    <StartingPageContent pageName="Njesi Raportuese">
      <NjesiRaportueseTable></NjesiRaportueseTable>
    </StartingPageContent>
  );
};

export default NjesiRaportuese;
